import { fromJS } from 'immutable';

import * as types from '../actions/actionTypes';

export const initialState = fromJS({
  gradeInstances: []
});

const gradeInstanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_GRADE_INSTANCES_SUCCESS: {
      return state.set('gradeInstances', fromJS(action.gradeInstances));
    }
    default: {
      return state;
    }
  }
};

export default gradeInstanceReducer;



// WEBPACK FOOTER //
// ./src/reducers/gradeInstanceReducer.js